import React from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type { FeaturedProducts } from "types/cms"
import { FeaturedProductsQuickShop } from "./FeaturedProductsQuickShop"

const FeaturedProductsWithCTA = React.lazy(() =>
  import("./FeaturedProductsWithCTA").then((mod) => ({
    default: mod.FeaturedProductsWithCTA,
  }))
)
const FeaturedProductsWithLink = React.lazy(() =>
  import("./FeaturedProductsWithLink").then((mod) => ({
    default: mod.FeaturedProductsWithLink,
  }))
)

type Props = CMSPageProps & FeaturedProducts

export const ProductSuggestions: React.FC<Props> = (props) => {
  const { cta, quickShop } = props

  const variationWithCta = !!cta

  if (quickShop) {
    return <FeaturedProductsQuickShop {...props} />
  }

  return variationWithCta ? (
    <FeaturedProductsWithCTA {...props} />
  ) : (
    <FeaturedProductsWithLink {...props} />
  )
}
